import pick from 'lodash-es/pick';
export function getUsableErrors(error) {
  return pick(error.response, ['status', 'statusText', 'data']);
}